// extracted by mini-css-extract-plugin
export default {"container":"NewGoal_container__pYjVI","editButton":"NewGoal_editButton__1CtTJ","editButtons":"NewGoal_editButtons__7iT+K","h3":"NewGoal_h3__w-p0l"};